import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import AssetCategorization, {
	mapCategoryColor,
	mapCategoryName,
} from "../data/asset-categorization";
import { AssetCategory } from "velavu-js-api";
import { classArr } from "../helper/style-helper";
import * as styles from "./categorization-tag.module.scss";
import whitelabel from "../whitelabel";
import { makeStyleable, StyleableIcon } from "../helper/icon-helper";
import IconCar from "../dynamicicons/icon-car";
import IconToolbox from "../dynamicicons/icon-toolbox";
import IconPerson from "../dynamicicons/icon-person";

//Category > Group
export default function CategorizationTag(props: {
	style?: CSSProperties;
	className?: string;

	categorization: AssetCategorization;

	selectable?: boolean;
	selected?: boolean;
	onClick?: () => void;
}) {
	const [bg, fg] = getColors(props.categorization.category, !!props.selected);

	return (
		<div
			style={{ backgroundColor: bg, color: fg, ...props.style }}
			className={classArr(
				styles.tag,
				styles.tagWithIcon,
				props.selectable && styles.selectable,
				props.className,
			)}
			onClick={props.onClick}
		>
			{getIcon(props.categorization.category)(16, "currentColor")}
			<span className={styles.label}>{props.categorization.group}</span>
		</div>
	);
}

//Category
export function CategoryTag(props: {
	style?: CSSProperties;
	className?: string;

	category: AssetCategory;

	selectable?: boolean;
	selected?: boolean;
	onClick?: () => void;
}) {
	const { t } = useTranslation();
	const [bg, fg] = getColors(props.category, !!props.selected);

	return (
		<div
			style={{
				backgroundColor: bg,
				color: fg,
				...props.style,
			}}
			className={classArr(
				styles.tag,
				styles.tagWithIcon,
				props.selectable && styles.selectable,
				props.className,
			)}
			onClick={props.onClick}
		>
			{getIcon(props.category)(16, "currentColor")}
			<span>{mapCategoryName(props.category, t)}</span>
		</div>
	);
}

//Group
export function GroupTag(props: {
	style?: CSSProperties;
	className?: string;

	categorization: AssetCategorization;

	selectable?: boolean;
	selected?: boolean;
	onClick?: () => void;
}) {
	const [bg, fg] = getColors(props.categorization.category, !!props.selected);

	return (
		<div
			style={{ backgroundColor: bg, color: fg, ...props.style }}
			className={classArr(
				styles.tag,
				props.selectable && styles.selectable,
				props.className,
			)}
			onClick={props.onClick}
		>
			{props.categorization.group}
		</div>
	);
}

function getColors(
	category: AssetCategory,
	selected: boolean,
): [string, string] {
	const [bg, fg] = mapCategoryColor(category);

	if (selected) {
		return [fg, whitelabel.palette.secondary50];
	} else {
		return [bg, fg];
	}
}

function getIcon(category: AssetCategory): StyleableIcon {
	switch (category) {
		case AssetCategory.Vehicle:
			return makeStyleable(IconCar);
		case AssetCategory.Equipment:
			return makeStyleable(IconToolbox);
		case AssetCategory.Person:
			return makeStyleable(IconPerson);
	}
}
